<template>
<div>
    <!-- Navigation Section -->
    <NavSection />
    <!-- Product Section -->
    <section class="product-section">
        <div class="product-div-wrap">
            <div class="product-div-box">
                <!-- Product Images -->
                <div class="product-images-div">
                 
                    <div class="product-image-slider w-slider" aria-roledescription="carousel">
                      <imageScroller :slides="product.images" v-if="isMobile"></imageScroller>
                      <div class="w-slider-mask" id="w-slider-mask-0"  v-else>
                            <div v-for="(img, index) in product.images" :key="`pimages-${index}`" class="product-slide w-slide" :aria-label="`${index + 1} of ${product.images.length}`" role="group" :aria-hidden="currentImageIndex !== index" :style="maskStyle">
                                <a href="#" class="w-inline-block w-lightbox" aria-label="open lightbox" aria-haspopup="dialog" :tabindex="currentImageIndex === index ? 0 : -1" @click.prevent="openLightbox(index)" :aria-hidden="currentImageIndex !== index">
                                    <div class="product-img-div" aria-hidden="true">
                                        <img :src="img.url" :alt="img.alt || ''" class="image-401" loading="lazy" :sizes="img.sizes" :srcset="img.srcset" />
                                    </div>
                                    <script type="application/json" class="w-json" aria-hidden="true">
                                    {{ JSON.stringify(img) }}
                                    </script>
                                </a>
                            </div>
                            <div aria-live="polite" aria-atomic="true" class="w-slider-aria-label">
                                Slide {{ currentImageIndex + 1 }} of {{ product.images.length }}
                            </div>
                      </div>

                        <!-- Left and Right Arrows -->
                        <div class="product-slider-left-arrow w-slider-arrow-left" @click="previousImage">
                            <div class="product-slider-arrow-icon w-icon-slider-left"></div>
                        </div>
                        <div class="product-slider-right-arrow w-slider-arrow-right" @click="nextImage">
                            <div class="product-slider-arrow-icon w-icon-slider-right"></div>
                        </div>

                        <!-- Dots Navigation -->
                        <div class="slide-nav-4 w-slider-nav w-round w-num">
                            <span v-for="(img, index) in product.images" :key="`dot-${index}`" :class="{'active-dot': currentImageIndex === index}" @click="goToImage(index)"></span>
                        </div>
                    </div>

                    <!-- Desktop Lightbox -->
                    <div class="desktop-lightbox-div">
                        <div class="lightbox-row">
                            <a v-for="(img, index) in product.images.slice(1, 3)" :key="index" href="#" class="w-inline-block w-lightbox" @click.prevent="openLightbox(index + 1)">
                                <img :src="img.url" loading="lazy" :alt="img.alt">
                            </a>
                        </div>
                        <div class="lightbox-row">
                            <a v-for="(img, index) in product.images.slice(3, 5)" :key="index" href="#" class="w-inline-block w-lightbox" @click.prevent="openLightbox(index + 3)">
                                <img :src="img.url" loading="lazy" :alt="img.alt">
                            </a>
                        </div>
                    </div>

                    <div class="category">{{ product.category.primary }}</div>
                </div>

                <!-- Product Details -->
                <div class="product-detail-div">
                    <div :class="`category_mobile ${product.category.primary.toLowerCase()}`">{{ product.category.primary }}</div>

                    <div class="ratings-div"><img src="@/assets/images/icon_stars.svg" loading="lazy" alt="" class="image-394">
                        <div class="rating-text">Rated <strong class="bold-text">4.9/5</strong> by <strong class="bold-text-2">100+</strong> Happy Customers</div>
                    </div>

                    <div class="product-name-box">
                        <div class="product-name">{{ product.name }}</div>
                        <div class="text-block-866">{{product.brand_name}}</div>
                        
                    </div>

                    <div class="product-price-div">
                        <div class="old-price-text">${{ (parseFloat(product.pricing.retail_price) * 1.33).toFixed(2)  }}</div>
                        <div class="price-text">${{ parseFloat(product.pricing.retail_price).toFixed(2)}}</div>
                        <div>
                            <div class="savings-text">SAVE 33%</div>
                        </div>

                    </div>

                    <div class="line-divider"></div>

                    <div class="description-header-text">{{ product.marketing.sub_header }}</div>

                    <!-- Product Features -->
                    <div v-for="(feature, index) in product.product_bullets" :key="index" class="product-bullet-div">
                        <img src="@/assets/images/icon_check-black2.svg" loading="lazy" alt="" class="image-395">
                        <div class="bullet-text">{{ feature }}</div>
                    </div>

                    <div class="div-block-1796">
                        <a href="#" class="link-block-69 w-inline-block">
                            <img src="@/assets/images/icon_chat_grn.svg" loading="lazy" alt="" class="image-427">
                            <div>Ask A Question</div>
                        </a>
                        <a href="#" class="link-block-69 w-inline-block">
                            <img src="@/assets/images/icon_read_grn.svg" loading="lazy" alt="" class="image-427">
                            <div>Read Article</div>
                        </a>
                    </div>

                    <div class="line-divider"></div>

                    <div class="order-arival-div">
                        <img src="@/assets/images/icon__Alert-dot.svg" loading="lazy" alt="" class="image-396">
                        <div class="text-block-770" v-html="`Order today and get it by <strong>${futureDate}</strong>`"></div>
                    </div>

                    <a href="#" class="add-to-cart-bttn w-button" @click.prevent="handleAddToCart">ADD TO CART</a>

                    <!-- Perks -->
                    <div class="perks-div">
                        <div class="perk-div">
                            <img src="@/assets/images/icon_shipping.svg" loading="lazy" alt="" class="image-386">
                            <div class="text-block-738"><strong>Overnight</strong> Shipping Today</div>
                        </div>
                        <div class="perk-div">
                            <img src="@/assets/images/icon_returns.svg" loading="lazy" alt="" class="image-386">
                            <div class="text-block-738"><strong>60 Day Money Back</strong> Guarantee</div>
                        </div>
                    </div>

                    <img src="@/assets/webp/Payment_Methods.webp" loading="lazy" alt="Payment Methods" class="image-399">

                    <!-- Mobile Lightbox -->
                    <div class="mobile-lightbox-div hide-from-mobile">
                        <div class="lightbox-row">
                            <a v-for="(img, index) in product.images.slice(1, 3)" :key="index" href="#" class="w-inline-block w-lightbox">
                                <img :src="img.url" loading="lazy" :alt="img.alt">
                            </a>
                        </div>
                        <div class="lightbox-row">
                            <a v-for="(img, index) in product.images.slice(3, 5)" :key="index" href="#" class="w-inline-block w-lightbox">
                                <img :src="img.url" loading="lazy" :alt="img.alt">
                            </a>
                        </div>
                    </div>

                    <!-- Product Dropdowns -->
                    <div class="dropdowns-set-adjust-div">
                        <div v-for="(dropdown, index) in product.dropdowns" :key="index" class="description-dropdown w-dropdown">
                            <div class="dropdown-toggle-5 w-dropdown-toggle" @click="toggleDropdown(index)">
                                <div class="icon-26 w-icon-dropdown-toggle"></div>
                                <div class="dropdown-header">{{ dropdown.header }}</div>
                            </div>
                            <nav :class="['dropdown-list-3', 'w-dropdown-list', { 'w--open': openDropdown === index }]">
                                <div class="w-form">
                                    <div class="form-9">
                                        <p class="paragraph-131" v-html="dropdown.text">
                                        </p>
                                        
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Allergen Section -->
    <section class="allergen-section" v-if="product.is_prescription !== 1">
        <div class="allergen-div-wrap">
            <div class="allergen-div">
                <div class="allergen-group">
                    <div v-for="n in 4" :key="`allergen1-${n}`" class="allergen-box pair">
                        <img src="images/icon_placeholder.png" loading="lazy" alt="" class="allergen-icon">
                    </div>
                </div>
                <div class="allergen-group">
                    <div v-for="n in 4" :key="`allergen2-${n}`" class="allergen-box pair">
                        <img src="images/icon_placeholder.png" loading="lazy" alt="" class="allergen-icon">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- 4 Things Section -->
    <section class="_4-things-section">
        <div class="_4things-wrap">
            <div class="_4things-div">
                <div class="div-block-1768">
                    <div class="div-block-1769">
                        <img :src="svgImage" loading="lazy" alt="">
                    </div>
                    <div class="text-block-828">
                        <strong>{{ product.benefits.pre_header_text }}</strong>
                    </div>
                </div>
                <div class="text-block-829">{{ product.benefits.main_text  }}</div>
                <p class="paragraph-130">{{ product.benefits.sub_header  }}</p>

                <!-- Benefits Grid -->
                <div v-for="(row, rowIndex) in [0, 1]" :key="`row-${rowIndex}`" class="div-block-1767">
                    <div v-for="(benefit, index) in product.benefits.key_points.slice(rowIndex * 2, (rowIndex + 1) * 2)" :key="`benefit-${index}`" class="div-block-1770">
                        <div class="div-block-1771">
                            <img :src="svgImageTwo" loading="lazy" alt="" >
                        </div>
                        <div class="div-block-1772">
                            <div class="text-block-827">{{ benefit.title }}</div>
                            <div class="_4things-text">{{ benefit.description }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <a href="#" class="add-to-cart-bttn w-button only-phone-show" @click.prevent="handleAddToCart">ADD TO CART</a>
        </div>
        
    </section>
    
    <!-- RX Steps Section -->
    <section class="rx-steps-section">
        <div class="rx-div-wrap">
            <div class="rx-div">
                <div class="div-block-1159">
                    <div class="text-block-256">Metabolic Science</div>
                    <h1 class="heading-59"><span class="text-span-187">On Demand</span>&nbsp;<br class="only-phone-show">Health Optimization. <br>Delivered to your Door.<br></h1>
                </div>

                <!-- Steps -->
                <div class="div-block-1160">
                    <div v-for="(step, index) in rxSteps" :key="index" class="div-block-1161">
                        <img :src="step.image" loading="lazy" alt="" class="image-421">
                        <div class="div-block-1786">
                            <div class="div-block-1787">
                                <div class="div-block-1785">
                                    <div class="text-block-858">{{ index + 1 }}</div>
                                </div>
                                <div class="text-block-857">{{ step.title }}</div>
                            </div>
                            <p class="paragraph-136">{{ step.description }}</p>
                        </div>
                    </div>
                </div>

                <div class="rx-section-button-div">
                    <a href="https://join.trueformrx.com/" class="button-85 w-button">
                        Take the Quiz & Qualify <span class="text-span-186">-></span>
                    </a>
                </div>
            </div>
        </div>
    </section>

    <!-- Product Links Section -->
    <section class="product-links-section">
        <div class="product-links-wrap">
            <div class="product-links-div">
                <div class="product-links-headr-div">
                    <div class="text-block-829">
                        More <strong>{{ toProperCase(product.category.primary) }}</strong> Products
                    </div>
                </div>
                <div class="product-links-flex-div">
                    <div class="link-pair">
                        <div v-for="(relatedProduct, index) in relatedProductsParts(0,2)" :key="`product-${index}`" class="product-preview-div product-template">
                            <ProductPreview :product="relatedProduct" :page="'product'" :index="index" />
                        </div>
                    </div>
                    <div class="link-pair">
                        <div v-for="(relatedProduct, index) in relatedProductsParts(2,4)" :key="`product-${index}`" class="product-preview-div product-template">
                            <ProductPreview :product="relatedProduct" :page="'product'" :index="index" />
                        </div>
                    </div>
                </div>
                <div class="div-block-1782">
                    <router-link :to="`/store?category=${product.category.primary}`" class="button-84 w-button">
                        More <strong>{{ toProperCase(product.category.primary) }}</strong> Products
                    </router-link>
                </div>
            </div>
        </div>
    </section>

    <!-- Review Section -->
    <section class="review-section">
        <div class="review-wrap">
            <div class="reviews-div">
                <div class="reviews-flex-div">
                    <div class="review-box" v-for="test in product.testimonials" :key="test.text">
                        <img src="@/assets/images/icon_stars_1.svg" loading="lazy" alt="" class="image-417">
                        <p class="paragraph-133">{{test.text}}</p>
                        <div class="reviewer-div">
                            <div class="reviewer-img-div"><img :src="test.image" loading="lazy" alt=""></div>
                            <div class="reviewer-info">
                                <div class="text-block-832">{{test.name}}</div>
                                <div class="text-block-833">{{test.address}}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>

    <!-- Table Section -->
    <section class="table-section">
        <div class="table-wrap">
            <div class="table-div">
                <div class="table-div-header">
                    What sets <strong><em>new</em></strong><span class="text-span-184"><strong>self</strong></span> apart
                </div>
                <div class="comparison-table">
                    <!-- Header Row -->
                    <div class="table-row top">
                        <div class="table-entry"></div>
                        <div class="ns-column">
                            <img src="@/assets/images/NewSelf_Logo.png" loading="lazy" sizes="(max-width: 479px) 26vw, 70.0234375px" srcset="@/assets/images/NewSelf_Logo-p-500.png 500w, @/assets/images/NewSelf_Logo-p-800.png 800w, @/assets/images/NewSelf_Logo.png 1000w" alt="" class="image-418">
                        </div>
                        <div class="other-column">
                            <div class="text-block-845">Competition</div>
                        </div>
                    </div>

                    <!-- Comparison Rows -->
                    <div v-for="(feature, index) in comparisonFeatures" :key="index" class="table-row">
                        <div class="table-entry">
                            <div class="text-block-846">{{ feature }}</div>
                        </div>
                        <div class="ns-column">
                            <img src="@/assets/images/icon_check-black2.svg" loading="lazy" alt="" class="image-419">
                        </div>
                        <div class="other-column">
                            <img src="@/assets/images/icon_check-x.svg" loading="lazy" alt="" class="image-419">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section">
        <div class="cta-wrap">
            <div class="cta-boxes-div">
                <div class="div-block-1780">
                    <div class="text-block-852">
                        Chat with the newself<br>AI-Powered Care Concierge
                    </div>
                    <p class="paragraph-135">
                        Our AI-Enabled Care concierge is here to help. Click below to ask whatever questions you have.
                    </p>
                    <a href="chat-window.html" class="button-84 w-button">Get Personalized Options</a>
                </div>
                <div class="div-block-1780">
                    <div class="text-block-852">
                        A Personalized Health Optimization Plan <strong>in minutes</strong>.
                    </div>
                    <p class="paragraph-135">
                        Find out which therapies are right for YOU. Take our short quiz and receive a detailed health report.
                    </p>
                    <a href="health-optimization-quiz.html" class="button-84 rev w-button">Take the Quiz</a>
                </div>
            </div>
        </div>
    </section>

    <!-- Video Section -->
    <section class="video-section">
        <div class="video-div-wrap">
            <div class="video-div">
                <div class="video-header-sub-div">
                    <div class="product-page-headers">WATCH THIS</div>
                    <div class="text-block-774">
                        {{ product.video_description || 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.' }}
                    </div>
                </div>
                <div class="video w-video w-embed" style="padding-top:56.17021276595745%">
                    <!-- Video embed code would go here -->
                </div>
            </div>
        </div>
    </section>

    <!-- Ingredients Section -->
    <section class="ingredients-section">
        <div class="ingredients-info-div-wrap">
            <div class="info-div">
                <div class="info-header-div">
                    <div class="product-page-headers">4 INGREDIENTS - ALL NATURAL</div>
                    <div class="text-block-774 left">
                        No fillers, no chemicals, just raw, unadulterated skin nutrition.
                    </div>
                </div>

                <div class="info-content-div">
                    <div v-for="(ingredient, index) in ingredients" :key="index" :class="['info-bar', { reverse: index % 2 === 1 }]">
                        <div class="info-pic-div">
                            <img :src="ingredient.image" loading="lazy" alt="" class="image-397">
                        </div>
                        <div class="div-block-1739">
                            <div class="text-block-772">{{ ingredient.name }}</div>
                            <div class="text-block-773">{{ ingredient.description }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Footer -->

    <!-- Lightbox Modal -->
    <div v-if="lightboxOpen" class="w-lightbox-backdrop" @click.self="closeLightbox" style="transition: all, opacity 300ms; opacity: 1;">
        <div class="w-lightbox-container">
            <div class="w-lightbox-content">
                <div class="w-lightbox-view" style="opacity: 1;">
                    <div class="w-lightbox-frame">
                        <figure class="w-lightbox-figure">
                            <img v-if="currentImage.type === 'image'" :src="currentImage.url" :alt="currentImage.alt" class="w-lightbox-img">
                            <iframe v-else-if="currentImage.type === 'video'" :src="currentImage.videoUrl" class="w-lightbox-embed" allowfullscreen>
                            </iframe>
                        </figure>
                    </div>
                </div>
                <div class="w-lightbox-control w-lightbox-left" @click="previousImage"></div>
                <div class="w-lightbox-control w-lightbox-right" @click="nextImage"></div>
                <div class="w-lightbox-control w-lightbox-close" @click="closeLightbox"></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { findProductByUrlName, getProductsByCategory } from '@/utils/productData'
import detectMobile from '@/utils/MobileDetection';
import { mapGetters, mapActions } from 'vuex'
import NavSection from './NavSection.vue'
import ProductPreview from '../shop/productCard.vue'
import imageScroller from './imageScroller.vue'

function generateProductImages(imagePreText) {
  const images = []
  const baseUrl = "https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/"
  
  for (let i = 1; i <= 5; i++) {
    images.push({
      id: i,
      type: "image",
      url: `${baseUrl}${imagePreText}/${i}.webp`,
      alt: `Product image ${i}`,
      is_featured: i === 1,
      origFileName: `${imagePreText}/${i}.webp`,
      fileName: `${imagePreText}/${i}.webp`,
      height: 1080,
      width: 1080
    })
  }
  
  return images
}

const colorMap = {
       'Weight': '#adff9e',
       'Mind': '#98deff',
       'Longevity': '#d1d9ff', 
       'Body': '#a3e0da',
       'Hair': '#ffbd98',
       'Skin': '#feffb5',
       'Sex': '#ff98f2'
     };

export default {
  name: 'ProductPage',
  components: {
    NavSection,
    ProductPreview,
    imageScroller
  },

  data() {
    return {
      lightboxOpen: false,
      product: null,
      currentImageIndex: 0,
      activeDropdown: null,
      autoplayInterval: null,
      autoplay: false,
      delay: 4000,
      error: null,
      isLoading: true,
      openDropdown: null,
      startX: 0,
      endX: 0,
      openMenu: false,
      slideWidth: 0,
      futureDate: this.getFutureDate(3),
      comparisonFeatures: [
        'Doctor Prescribed Revolutionary Therapies.',
        'Synergistic Supplements for the whole body.',
        'Access to network of nationwide pharmacies.',
        'A.I. Enabled Health Optimization Tools.',
        'Chat & Email Access to Clinical Resources.'
      ],
      rxSteps: [
        {
          image: require('@/assets/webp/steps_phoneform.webp'),
          title: 'Take Quiz',
          description: 'Complete a brief form to get pre-approved instantly.'
        },
        {
          image: require('@/assets/webp/icon_doc1.webp'),
          title: 'Doctor Review',
          description: 'Meet with our doctors over chat or a video call'
        },
        {
          image: require('@/assets/webp/RxSteps_meds.webp'),
          title: 'Get meds',
          description: 'Get your meds delivered to your doorstep overnight.'
        },
        {
          image: require('@/assets/webp/RxSteps_call.webp'),
          title: 'Clinical Access',
          description: 'Access to clinicians to help you along the way.'
        }
      ],
      socials: [
        { icon: require('@/assets/images/icon_ig.svg') },
        { icon: require('@/assets/images/icon_fb-cntered.svg') },
        { icon: require('@/assets/images/icon_x.svg') }
      ],
      footerLinks1: [
        { path: '/hipaa', text: 'HIPAA Notice' },
        { path: '/privacy-policy', text: 'Privacy Policy' },
        { path: '/returns-and-refund', text: 'Returns & Refund Policy' },
        { path: '/terms-of-use', text: 'Terms Of Use' }
      ],
      footerLinks2: [
        { path: '/ccpa', text: 'CCPA Opt-Out' },
        { path: '/telehealth-consent', text: 'Tele Health Consent' },
        { path: '/safety', text: 'Safety' }
      ],
      legalText: `NewSelf is a patient management platform that works with independent physicians and practitioners who provide services utilizing the NewSelf Engagement Platform. NewSelf does not directly provide medical or pharmacy services and payment does not guarantee the writing or dispensing of a prescription. Medical Services are provided via independent providers. The information provided on this website is for informational purposes and not a substitute for professional medical advice, diagnosis, or treatment. If you have questions or concerns about your health, please talk to your doctor. This site is an advertisement for services and not any specific medication.`
    }
  },
 
  computed: {
    ...mapGetters([
      'isCartOpen',
      'cartItemCount'
    ]),
    
    savingsPercentage() {
      if (!this.product) return 0
      const retail = parseFloat(this.product.pricing.retail_price)
      const discounted = parseFloat(this.product.pricing.discounted_price)
      return Math.round(((retail - discounted) / retail) * 100)
    },

    currentImage() {
      return this.product?.images[this.currentImageIndex] || {}
    },
    benefits() {
      if (!this.product) return []
      return [
        {
          header: this.product.benefit_1_header,
          description: this.product.benefit_1_description
        },
        {
          header: this.product.benefit_2_header,
          description: this.product.benefit_2_description
        },
        {
          header: this.product.benefit_3_header,
          description: this.product.benefit_3_description
        },
        {
          header: this.product.benefit_4_header,
          description: this.product.benefit_4_description
        }
      ]
    },

    testimonials() {
      if (!this.product) return []
      return [
        {
          text: this.product.testimonial_1,
          name: this.product.testimonial_name_1,
          address: this.product.testimonial_city_state_1,
          image: require('@/assets/images/testi1.jpg')
        },
        {
          text: this.product.testimonial_2,
          name: this.product.testimonial_name_2,
          address: this.product.testimonial_city_state_2,
          image: require('@/assets/images/testi2.jpg')
        },
        {
          text: this.product.testimonial_3,
          name: this.product.testimonial_name_3,
          address: this.product.testimonial_city_state_3,
          image: require('@/assets/images/testi3.jpg')
        }
      ]
    },

    ingredients() {
      return [
        {
          name: 'Manuka Honey',
          description: 'Heals and replenishes your skin thanks to its antibacterial, anti-inflammatory, healing, and anti-aging effects.',
          image: require('@/assets/webp/placeholder1.webp')
        },
        {
          name: 'Grass-Fed / Finished Beef Tallow',
          description: 'Nourishes your skin\'s cell membranes. Rich in vitamins A, D, E, K, and B1. Also contains CLA, which is a natural anti-inflammatory.',
          image: require('@/assets/webp/placeholder2.webp')
        },
        {
          name: 'Cold-Pressed Organic Olive Oil',
          description: 'Used for millennia to moisturize skin. It\'s moisturizing magic has been proven time and time again in clinical studies.',
          image: require('@/assets/webp/placeholder3.webp')
        },
        {
          name: 'Pot Marigold Extract',
          description: 'Heals your skin thanks to its anti-inflammatory and wound-healing effects. Used since prehistoric times.',
          image: require('@/assets/webp/placeholder4.webp')
        }
      ]
    },

    relatedProducts() {
        if (!this.product || !this.product.category.primary) return []
        
        // Import all products from your product data
        const allProducts = getProductsByCategory(this.product.category.primary)
        
        // Filter out the current product and limit to 4 related products
        return allProducts
            .filter(prod => prod.sku !== this.product.sku)  // Remove current product
            .slice(0, 4)
    },
    isMobile() {
      return detectMobile()
    },
    maskStyle2() {
          if (this.isMobile) {
            return {
              transform: `translateX(-${this.currentImageIndex * this.slideWidth}px)`,
              transition: this.isTransitioning ? 'transform 0.3s ease-out' : 'none'
            };
          }
          let term = 460.797 * (this.currentImageIndex % this.totalSlides);
      return {
        transform: `translateX(-${term}px)`,
        transition: 'all , transform 500ms',
        opacity: '1'
      };
    },
    
    maskStyle() {
      let term =  460.797 * this.currentImageIndex;
      if(this.isMobile){
        if(this.currentImageIndex==0){
          term = 0;
        }else if(this.currentImageIndex==1){
          term = 585.876
        }else if(this.currentImageIndex==2){
          term = 799.875
        }else if(this.currentImageIndex===5){
          term = 0
        }
        
      }
      
      return {
        transform: `translateX(-${term}px)`,
        transition: 'all , transform 500ms',
        opacity: '1'
        
      };
    },
    svgImageTwo(){
        const fill = colorMap[this.product.category.primary] || '#fff';
        const svg = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="50 -50 300 300" style="enable-background:new 50 -50 300 300;" xml:space="preserve">
          <style type="text/css">
            .st0{fill:${fill};}
          </style>
          <g id="Layer_2">
          </g>
          <g id="Layer_1_1_">
            <path id="XMLID_29_" class="st0" d="M98,103.1l22.4-20.2l45.4,35.9c0,0,49.3-62.2,127.2-95.3l9,12.9c0,0-82.4,43.7-133.9,140.1
              L98,103.1z"/>
          </g>
          </svg>`
          return 'data:image/svg+xml,' + encodeURIComponent(svg);
    },
    svgImage() {     
     const fill = colorMap[this.product.category.primary] || '#fff';
     const svg = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="-527 529 24 24" style="enable-background:new -527 529 24 24;" xml:space="preserve">
             <style type="text/css">
               .st0{fill:${fill};}
             </style>
             <g>
               <path class="st0" d="M-515,530c6.1,0,11,4.9,11,11s-4.9,11-11,11s-11-4.9-11-11S-521.1,530-515,530 M-515,529c-6.6,0-12,5.4-12,12
                 s5.4,12,12,12c6.6,0,12-5.4,12-12S-508.4,529-515,529L-515,529z"/>
             </g>
             <g>
               <circle class="st0" cx="-515" cy="541" r="8.3"/>
             </g>
             </svg>`;
     return 'data:image/svg+xml,' + encodeURIComponent(svg);
   } 
  },

  methods: {
    ...mapActions([
      'setCartVisibility',
      'addToCart'
    ]),
    calculateSlideWidth() {
      const slider = document.querySelector('.w-slider-mask');
      if (slider) {
        this.slideWidth = slider.offsetWidth;
      }
    },
    relatedProductsParts(val1, val2) {
        if (!this.relatedProducts || !this.relatedProducts) return []
                
        // Filter out the current product and limit to 4 related products
        return this.relatedProducts
            .filter(prod => prod.sku !== this.product.sku)  // Remove current product
            .slice(val1, val2)
    },
    
    toProperCase(str) {
      if (str === 'WEIGHT') return "Weight Loss"
      return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())
    },

    processProductData(product) {
      if (product.image_pre_text) {
        product.images = generateProductImages(product.image_pre_text)
      }
      return product
    },

    getFutureDate(days) {
      const date = new Date()
      date.setDate(date.getDate() + days)
      const weekday = date.toLocaleDateString('en-US', { weekday: 'short' })
      const month = date.toLocaleDateString('en-US', { month: 'short' })
      const day = date.getDate()
      return `${weekday}, ${month} ${day}<sup>${this.getOrdinalSuffix(day)}</sup>`
    },

    getOrdinalSuffix(day) {
      if (day >= 11 && day <= 13) return 'th'
      switch (day % 10) {
        case 1: return 'st'
        case 2: return 'nd'
        case 3: return 'rd'
        default: return 'th'
      }
    },

    toggleDropdown(index) {
      this.openDropdown = this.openDropdown === index ? null : index
    },

    nextImage() {
      if (!this.product?.images.length) return
      this.currentImageIndex = (this.currentImageIndex + 1) % this.product.images.length
    },
    goToImage(index) {
      this.currentImageIndex = index;
    },
    previousImage() {
      if (!this.product?.images.length) return
      this.currentImageIndex = this.currentImageIndex === 0 
        ? this.product.images.length - 1 
        : this.currentImageIndex - 1
    },
    startAutoplay() {
      if (this.autoplay) {
        this.autoplayInterval = setInterval(this.nextImage, this.delay);
      }
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    },
    getSlideStyle(index) {
      return {
        transition: 'all 500ms',
        transform: `translateX(${(index - this.currentImageIndex) * 100}%)`,
        opacity: this.currentImageIndex === index ? 1 : 0,
      };
    },
    setActiveImage(index) {
      if (index >= 0 && index < this.product?.images.length) {
        this.currentImageIndex = index
      }
    },

    openLightbox(index) {
      this.currentImageIndex = index
      this.lightboxOpen = true
      document.body.style.overflow = 'hidden'
    },

    handleTouchStart(event) {
      this.startX = event.touches[0].clientX;
    },
    handleTouchMove(event) {
      this.endX = event.touches[0].clientX;
    },
    handleTouchEnd() {
      const swipeDistance = this.startX - this.endX;
      const swipeThreshold = 50; // Minimum distance to count as a swipe

      if (swipeDistance > swipeThreshold) {
        // Swipe left
        this.nextImage();
      } else if (swipeDistance < -swipeThreshold) {
        // Swipe right
        this.previousImage();
      }
    },
    closeLightbox() {
      this.lightboxOpen = false
      document.body.style.overflow = ''
    },

    handleKeyNavigation(event) {
      if (!this.lightboxOpen) return
      
      switch(event.key) {
        case 'ArrowLeft':
          this.previousImage()
          break
        case 'ArrowRight':
          this.nextImage()
          break
        case 'Escape':
          this.closeLightbox()
          break
      }
    },

    async loadProduct() {
      try {
        this.isLoading = true
        const productUrlName = this.$route.params.productName
        const foundProduct = findProductByUrlName(productUrlName)
        
        if (foundProduct) {
          this.product = this.processProductData(foundProduct);
          this.error = null
          document.title = `${foundProduct.name} | NewSelf`
          this.updateMetaTags(foundProduct)
          window.scrollTo({ top: 0, behavior: 'smooth' })
        } else {
          this.error = 'Product not found'
          this.$router.push('/404')
        }
      } catch (error) {
        console.error('Error loading product:', error)
        this.error = 'Error loading product'
      } finally {
        this.isLoading = false
      }
    },

    updateMetaTags(product) {
      const metaDescription = document.querySelector('meta[name="description"]')
      if (metaDescription) {
        metaDescription.setAttribute('content', product.shop_page_description)
      }

      // Open Graph tags
      const ogTitle = document.querySelector('meta[property="og:title"]')
      const ogDescription = document.querySelector('meta[property="og:description"]')
      const ogImage = document.querySelector('meta[property="og:image"]')

      if (ogTitle) ogTitle.setAttribute('content', product.name)
      if (ogDescription) ogDescription.setAttribute('content', product.shop_page_description)
      if (ogImage && product.images?.[0]) ogImage.setAttribute('content', product.images[0].url)
    },

    handleAddToCart() {
      if (!this.product) return

      const cartItem = {
        id: this.product.id,
        name: this.product.name,
        category: this.product.category,
        price: this.product.pricing.retail_price,
        retail_price: (parseFloat(this.product.pricing.retail_price) * 1.33).toFixed(2),
        subheader: this.product.brand_name,
        sku: this.product.sku,
        stripe_id: this.product.stripe_id,
        quantity: 1,
        image: this.product.images[0]?.url,
        main_type: this.product.is_prescription
      }
      console.log("adding item")
      console.log(cartItem)
      this.$store.dispatch('addToCart', cartItem);
    }
  },

  created() {
    this.loadProduct()
  },

  mounted() {
    window.addEventListener('keydown', this.handleKeyNavigation);
    this.startAutoplay();
    window.addEventListener('resize', this.calculateSlideWidth);
    this.$el.addEventListener('touchstart', this.handleTouchStart);
    this.$el.addEventListener('touchmove', this.handleTouchMove);
    this.$el.addEventListener('touchend', this.handleTouchEnd);
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyNavigation)
    this.stopAutoplay();
    window.removeEventListener('resize', this.calculateSlideWidth);
    this.$el.removeEventListener('touchstart', this.handleTouchStart);
    this.$el.removeEventListener('touchmove', this.handleTouchMove);
    this.$el.removeEventListener('touchend', this.handleTouchEnd);
    // Clean up any other event listeners or third-party plugins
  },

  watch: {
    '$route'(to, from) {
      if (to.params.productName !== from.params.productName) {
        this.loadProduct()
      }
    }
  }
}
</script>

<style scoped>
.light-video {
    width: 100% !important;
    height: 100% !important;
}

.open-menu {
    display: block !important;
}
.category_mobile.weight { background-color: var(--weight); }
.category_mobile.mind { background-color: var(--mind); }
.category_mobile.longevity { background-color: var(--longevity); }
.category_mobile.body { background-color: var(--body); }
.category_mobile.hair { background-color: var(--hair); }
.category_mobile.skin { background-color: var(--skin); }
.category_mobile.sex { background-color: var(--sex); }

@media screen and (max-width: 479px) {
    .text-block-827 {
        font-size: 25px;
    }
    ._4things-text {
        font-size: 19px;
    }
}
</style>
